import { InjectionToken } from '@angular/core';

export const AUTH_SERVICE_TOKEN = new InjectionToken<any>('AuthService');
